import Box from '@mui/material/Box';
import { Button, Card, CardContent, Checkbox, FormControlLabel, FormGroup, List, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import { useState } from 'react';


const SkuDisplay = props => {
    const [quantity, setQuantity] = useState(1);
    const [printHangTags, setPrintHangTags] = useState(false);
    const [printAsinLabels, setPrintAsinLabels] = useState(false);
    const [printChewyLabels, setPrintChewyLabels] = useState(false);
    const [printWalmartLabels, setPrintWalmartLabels] = useState(false);

    const print = () => {
        if (!quantity || isNaN(quantity)) {
            props.toast.error("Please provide a numeric value for quantity");
            return;
        }

        if (!printHangTags && !printAsinLabels && !printChewyLabels && !printWalmartLabels) {
            props.toast.error("Please select a type of label to print");
            return;
        }

        const printOptions = {
            quantity,
            printHangTags,
            printAsinLabels,
            printChewyLabels,
            printWalmartLabels
        };

        props.printItem(printOptions);
    };

    const listItemStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    };

    const listItemTextStyles = {
        mt: -1,
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        paddingLeft: 2,
        paddingRight: 2
    };

    const enableHangTagPrinting = props.hangTagPrinters.length;
    const enableAsinLabelPrinting = props.asinLabelPrinters.length && props.item.amazon_description?.length;
    const enableChewyLabelPrinting = props.asinLabelPrinters.length && props.item.chewy_description?.length;
    const enableWalmartLabelPrinting = props.asinLabelPrinters.length && props.item.walmart_sku?.length;

    return (
        <Box sx={{ width: "80%" }} className={props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
            <Card sx={{ height: 260, width: 400, display: "inline-block", margin: 2 }}>
                <CardContent>
                    <Box sx={{ p: "20px", display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: -2.5, mb: -3.8 }}>
                        <Typography gutterBottom variant="h5" component="div">SKU {props.item.sku}</Typography>
                    </Box>
                    <Box sx={{ p: "20px", width: "100%" }}>
                        <List dense>
                            <ListItem disableGutters sx={listItemStyles}>
                                <ListItemText sx={listItemTextStyles} primary="Size" secondary={props.item.size} />
                            </ListItem>
                            <ListItem disableGutters sx={listItemStyles}>
                                <ListItemText sx={listItemTextStyles} primary="Color" secondary={props.item.color} />
                            </ListItem>
                            <ListItem disableGutters sx={listItemStyles}>
                                <ListItemText sx={listItemTextStyles} primary="Pretagged" secondary={props.item.pretagged} />
                            </ListItem>
                            <ListItem disableGutters sx={listItemStyles}>
                                <ListItemText sx={listItemTextStyles} primary="UPC" secondary={props.item.upc} />
                            </ListItem>
                            <ListItem disableGutters sx={listItemStyles}>
                                <ListItemText sx={listItemTextStyles} primary="ASIN" secondary={props.item.asin} />
                            </ListItem>
                            <ListItem disableGutters sx={listItemStyles}>
                                <ListItemText sx={listItemTextStyles} primary="Chewy SKU" secondary={props.item.chewy_sku} />
                            </ListItem>
                            <ListItem disableGutters sx={listItemStyles}>
                                <ListItemText sx={listItemTextStyles} primary="Walmart SKU" secondary={props.item.walmart_sku} />
                            </ListItem>
                        </List>
                    </Box>
                </CardContent>
            </Card>

            <div style={{ display: "inline-block", verticalAlign: "top", marginTop: 30, marginLeft: 10 }}>
                <TextField style={{ marginBottom: 10 }} label="Quantity" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                <FormGroup>
                    <FormControlLabel label="Hang tag" control={<Checkbox checked={printHangTags} onChange={event => setPrintHangTags(event.target.checked)} disabled={!enableHangTagPrinting} />}/>
                    <FormControlLabel label="ASIN label" control={<Checkbox checked={printAsinLabels} onChange={event => setPrintAsinLabels(event.target.checked)} disabled={!enableAsinLabelPrinting}/>}/>
                    <FormControlLabel label="Chewy label" control={<Checkbox checked={printChewyLabels} onChange={event => setPrintChewyLabels(event.target.checked)} disabled={!enableChewyLabelPrinting} />}/>
                    <FormControlLabel label="Walmart label" control={<Checkbox checked={printWalmartLabels} onChange={event => setPrintWalmartLabels(event.target.checked)} disabled={!enableWalmartLabelPrinting} />} />
                </FormGroup>
            </div>

            <Button sx={{ width: 100, margin: 0.5, marginTop: 15, verticalAlign: "top", float: "right" }} color="success" onClick={print} variant="contained">Print</Button>
        </Box>
    );

};

export default SkuDisplay;